document.addEventListener("DOMContentLoaded", function () {
  const blogContainer = document.querySelector(".article-template__content");
  const firstParagraph = blogContainer.querySelector("p");

  // Get all h tags after first paragraph
  const headings = Array.from(
    blogContainer.querySelectorAll("h1, h2, h3, h4, h5, h6")
  ).filter(
    (h) =>
      h.compareDocumentPosition(firstParagraph) ===
      Node.DOCUMENT_POSITION_PRECEDING
  );

  console.log("headings", headings);

  // Add unique IDs to each heading
  headings.forEach((heading, index) => {
    console.log("tag name", heading.tagName);
    heading.id = `heading-${index}`;
  });

  if (headings.length < 1) return;

  // Create table
  const table = document.createElement("table");
  table.classList.add("article-jump-table");
  table.innerHTML = `
        <thead>
            <tr>
                <th>Jump To</th>
            </tr>
        </thead>
        <tbody>
            ${headings
              .map(
                (heading, index) => `
                <tr>
                    <td class="heading-link ${heading.tagName}" data-target="heading-${index}">
                        ${heading.textContent}
                    </td>
                </tr>
            `
              )
              .join("")}
        </tbody>
    `;

  // Insert table after first paragraph
  firstParagraph.insertAdjacentElement("afterend", table);

  // Add click event listeners to table rows
  const links = table.querySelectorAll(".heading-link");
  links.forEach((link) => {
    link.addEventListener("click", function (e) {
      const targetId = this.getAttribute("data-target");
      const targetHeading = document.getElementById(targetId);

      if (targetHeading) {
        targetHeading.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
    });
  });

  // Optional: Add some basic styling
  const style = document.createElement("style");
  style.textContent = `
        .article-jump-table {
         
          border-collapse: collapse;
          margin: 20px 0;
          width: 100%;
          max-width: 500px;
          
          th, td {
              border: 1px solid #ddd;
              padding: 8px;
              text-align: left;
          }
          td{
            padding-block: .6em !important;
            font-size: 13px;
            color: rgba(var(--color-link),var(--alpha-link));
          }
          .heading-link {
              cursor: pointer;
              transition: background-color 0.3s;
          }
          .heading-link:hover {
              background-color: #f5f5f5;
          }
          .heading-link.H1{}
          .heading-link.H2{
              padding-left: 10px;
          }
          .heading-link.H3{
              padding-left: 20px;
          }
          .heading-link.H4{
              padding-left: 30px;
          }
          .heading-link.H5{
              padding-left: 40px;
          
          }
          .heading-link.H6{
              padding-left: 50px;
          }
        }
    `;
  document.head.appendChild(style);
});
